// import node_modules
import 'bootstrap';

// owl.carousel
import 'owl.carousel';

// Load Events
jQuery(document).ready(function ($) {
  $('#logo-carousel').owlCarousel({
    loop: true,
    margin: 10,
    autoplayTimeout: 5000,
    responsive: {
      0: {
        autoplay: true,
        items: 2,
      },
      768: {
        autoplay: true,
        items: 3,
      },
      1024: {
        items: 6,
      },
    },
  });
});
